import { FileShareDiscoveryRangeRequestModel } from '../../microsoft/fileshare/file-share-discovery-range-request-model';

export class FileShareDiscoveriesRequestModel {
  ranges: FileShareDiscoveryRangeRequestModel[];
}
